"use client";

import { type ReactNode } from "react";

import {
  Tooltip as ChakraTooltip,
  Portal,
  type TooltipRootProps
} from "@chakra-ui/react";

import { asSlotComponent } from "../internal/v3-slot";

const TooltipTrigger = asSlotComponent(ChakraTooltip.Trigger);
const TooltipPositioner = asSlotComponent(ChakraTooltip.Positioner);
const TooltipContent = asSlotComponent(ChakraTooltip.Content);
const TooltipArrow = asSlotComponent(ChakraTooltip.Arrow);

export interface TooltipProps extends Omit<TooltipRootProps, "children"> {
  label?: ReactNode;
  hasArrow?: boolean;
  disabled?: boolean;
  gutter?: number;
  children?: ReactNode;
}

export function Tooltip({
  label,
  hasArrow,
  disabled,
  gutter,
  placement,
  children,
  ...props
}: TooltipProps) {
  if (disabled) {
    return <>{children}</>;
  }

  // `asChild` needs a single ref-able element; v2 Tooltip also accepted plain text.
  const trigger =
    typeof children === "string" || typeof children === "number" ? (
      <span>{children}</span>
    ) : (
      children
    );

  return (
    <ChakraTooltip.Root
      positioning={{ placement, gutter }}
      disabled={disabled}
      {...props}
    >
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <Portal>
        <TooltipPositioner>
          <TooltipContent>
            {hasArrow ? <TooltipArrow /> : null}
            {label}
          </TooltipContent>
        </TooltipPositioner>
      </Portal>
    </ChakraTooltip.Root>
  );
}

export const ToolTipComponentStyle = {};
